import { systemAlertService, SystemAlertTypes } from '@/lib/systemAlerts/SystemAlertsService';

export default {
  userName: (state) => state.activeUser && state.activeUser.name,
  userEmail: (state) => state.activeUser && state.activeUser.email,
  isAuthenticated: (state) => state.activeUser !== null,
  userFirstName: (state) => state.activeUser && state.activeUser.given_name,
  hasPicture: (state) => state.activeUser && state.activeUser.profile,
  avatar: (state) => state.activeUser && (state.activeUser.profile || state.activeUser.name),
  rightPanel: (state) => state.rightPanel,
  deployments: (state) => state.deployments,
  deploymentindexes: (state) => state.userDeployments?.currentDeployment?.deploymentIndexes || [],
  selectedDeployment: (state) => state.userDeployments?.currentDeployment,
  selectedDeploymentIndex: (state) => state.userDeployments?.currentDeployment?.currentIndex,
  unreadNotifications: (state) => state.discoveryNotifier.unreadCount,
  selectedDeploymentIndexPreviewable: (state) => state
    .userDeployments?.currentDeployment?.currentIndex?.isPreviewable,
  hasBusyError: (state) => {
    const hasError = state.busyErrors.length > 0;
    console.log('getter hasError');
    console.log(hasError);
    return hasError;
  },
  indexColor: (state) => state.currentDeployment?.primaryColor,
  isSearchInitiated: (state) => state.searchLog.source !== '',
  myIndices: (state) => state.userSites,
  isMaintenanceAlertAcknowledged: () => systemAlertService.getIsSystemAlertAcknowledged(SystemAlertTypes.MAINTENANCE),
  isOpenAiAcknowledged: () => systemAlertService.getIsSystemAlertAcknowledged(SystemAlertTypes.OPEN_AI),
  isUserAssignedToCurrentSite: (state) => state.userSites.some((site) => site.deploymentIndexId === state.currentSiteId),
  userHasAccess: (state, getters) => {
    if (!state.userSites || state.userSites.length === 0) {
      return false;
    }

    if (state.currentSiteId != null && state.currentSiteId === 0) {
      return true;
    }
    return getters.isUserAssignedToCurrentSite;
  },
  siteAccessError: (state, getters) => {
    if (getters.userHasAccess) {
      return null;
    }

    if (!state.userSites || state.userSites.length === 0) {
      // if the url contains a siteId, then we use the forbiddenSite
      return (!!state.currentSiteId) ? 'forbiddenSite' : 'noSitesAssigned';
    }

    if (!getters.isUserAssignedToCurrentSite) {
      return 'forbiddenSite';
    }

    return 'unknownError';
  },

  canUserViewPage: (state, getters) => state.sitesLoaded && getters.userHasAccess,
};
